import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastMessage = () => {
  return <ToastContainer position="bottom-right" />;
};

export default ToastMessage;
